<section class="vc-admin-treatments-list">
  <app-admin-list-toolbar
    titleKey="ADMIN.TREATMENTS.ALL"
    descriptionKey="ADMIN.IA.TREATMENTS.DESCRIPTION"
    [showSearch]="true"
    searchPlaceholderKey="COMMON.SEARCH"
    [searchValue]="searchValue"
    (searchValueChange)="onSearch($event)"
  >
    <button
      toolbar-actions
      pButton
      type="button"
      icon="fas fa-plus"
      class="p-button-sm"
      [label]="'COMMON.ADD' | translate"
      (click)="router.navigate(['/administration', customer_route_param, 'treatments', 'new'])"
    ></button>
  </app-admin-list-toolbar>

  @if (filteredTreatments.length === 0) {
    <app-admin-state-panel
      mode="empty"
      titleKey="ADMIN.TREATMENTS.EMPTY.TITLE"
      descriptionKey="ADMIN.TREATMENTS.EMPTY.DESCRIPTION"
    ></app-admin-state-panel>
  } @else {
    <p-table
      [paginator]="true"
      [rows]="20"
      [rowsPerPageOptions]="[20, 40, 100]"
      [value]="filteredTreatments"
      responsiveLayout="scroll"
      [autoLayout]="true"
      styleClass="Table"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "COMMON.COLOR" | translate }}</th>
          <th>{{ "COMMON.ACTIVE" | translate }}</th>
          <th>{{ "COMMON.CATEGORY" | translate }}</th>
          <th>{{ "COMMON.NAME" | translate }}</th>
          <th>{{ "COMMON.DESCRIPTION" | translate }}</th>
          <th>{{ "COMMON.ACTIONS" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-treatment>
        <tr>
          <td [style]="{ 'background-color': treatment.color }"></td>
          <td>
            {{
              treatment.active
                ? ("COMMON.ACTIVE" | translate)
                : ("COMMON.INACTIVE" | translate)
            }}
          </td>
          <td>{{ treatment.category?.name }}</td>
          <td>{{ treatment.name }}</td>
          <td>{{ treatment.description }}</td>
          <td>
            <app-admin-table-actions
              [manageRouterLink]="[
                '/administration',
                customer_route_param,
                'treatments',
                treatment.id
              ]"
              (delete)="confirmDelete(treatment)"
            ></app-admin-table-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
